export const partnerAnalyticsPrefix = '[Partner]';
/**
 * These are the keys in AccountBM
 * that can be and must be copied/picked as-is
 * for PartialAccountForPartner.
 */
export const requiredAccountPropsForPartners = [
// required props
'lang', 'billingCountryCode', 'updated', 'regDate', 'hwId', 'id', 'appId', 'activationChannel',
// props needed for partner view
'appConsent', 'goal', 'fahrenheit', 'firstDayOfWeek', 'imperialUnits', 'pregnantNow', 'externalAccountId', 'height', 'weight'];
/**
 * These are the keys in AccountBM,
 * which are required for PartialAccountForPartner,
 * (in order to satisfy other types that use it),
 * but value of these fields are set manually,
 * rather than blindly copying from AccountBM.
 */
export const partialAccountForPartnerProps = [...requiredAccountPropsForPartners, 'appSettings', 'reminders', 'achievements', 'medicalStats'];
/**
 * These are the keys in PAccount
 * that can be and must be copied/picked as-is
 * for PartialPAccountForPartner.
 */
export const requiredPAccountPropsForPartners = ['id', 'email', 'name1', 'name2', 'externalPersonalId'];